export default __webpack_public_path__ + "static/media/img (1).57be0d55.jpg";